import React from 'react';

import { ModalForm } from '../../design-system/patterns/modal-form';

/**
 * The payment outcome.
 *
 * Both outcomes take the same shape and the same ink commit. Outcome colour
 * belongs to a status disc on the status splash routes, not to a tinted button
 * in a dialog, so nothing here is coloured by result.
 *
 * `ModalForm` for the track split — see ProceedPaymentModal. `showCancel` is
 * false because this dialog reports a result and has exactly one way forward:
 * a Cancel beside "Continue" would offer to dismiss an outcome that has already
 * happened.
 */
const PaymentResultModal = ({ isOpen, onClose, paymentStatus, onSuccess, onFailure }) => {
  const succeeded = paymentStatus === 'success';

  return (
    <ModalForm
      open={isOpen}
      onClose={onClose}
      title={succeeded ? 'Payment successful' : 'Payment failed'}
      onSubmit={() => {
        const go = succeeded ? onSuccess : onFailure;
        if (go) go();
      }}
      submitLabel={succeeded ? 'Continue' : 'Review'}
      showCancel={false}
    >
      <p>
        {succeeded
          ? 'Your payment was processed successfully.'
          : 'We could not process your payment. Please try again.'}
      </p>
    </ModalForm>
  );
};

export default PaymentResultModal;
